<section class="style-guide">
  <div class="container">
    <section class="content-panel grid">
      <div class="content--primary col-8 col-6--md col-4--sm col-start-2">
        <div class="style-guide-block">
          <span class="style-guide-block__label">Typography</span>
          <h1>H1: The quick brown fox jumps over the lazy dog</h1>
          <h2>H2: The quick brown fox jumps over the lazy dog</h2>
          <h3>H3: The quick brown fox jumps over the lazy dog</h3>
          <h4>H4: The quick brown fox jumps over the lazy dog</h4>
          <h5>H5: The quick brown fox jumps over the lazy dog</h5>
          <h6>H6: The quick brown fox jumps over the lazy dog</h6>

          <p>
            P: Maecenas sed diam eget risus varius blandit sit amet non magna. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
            dolor auctor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Aenean eu leo quam. Pellentesque ornare sem lacinia
            quam venenatis vestibulum.
          </p>
        </div>

        <div class="style-guide-block">
          <span class="style-guide-block__label">Button group</span>
          <div class="button__group">
            <div class="button button--primary" role="button">
              <span>Primary</span>
            </div>
            <div class="button button--secondary" role="button">
              <span>Secondary</span>
            </div>
            <div class="button button--tertiary" role="button">
              <span>Tertiary</span>
            </div>
            <div class="button button--border" role="button">
              <span>Border</span>
            </div>
          </div>
        </div>

        <div class="style-guide-block">
          <span class="style-guide-block__label">Button with loader</span>
          <div class="button__group">
            <div class="button button--primary" role="button" [airButtonLoading]="buttonIsLoading">
              <span>Primary loading</span>
            </div>
            <div class="button button--secondary" role="button" [airButtonLoading]="buttonIsLoading === false">
              <span>Secondary loading</span>
            </div>
          </div>
        </div>

        <div class="style-guide-block">
          <div class="button button--primary" role="button" (click)="openModal()">
            <span>Open modal</span>
          </div>
        </div>

        <div class="style-guide-block">
          <span class="style-guide-block__label">Shadows</span>
          <div class="shadow shadow--01"></div>
          <div class="shadow shadow--02"></div>
          <div class="shadow shadow--03"></div>
        </div>

        <div class="style-guide-block">
          <span class="style-guide-block__label">Horizontal line</span>
          <hr />
        </div>

        <div class="style-guide-block formatted-text__body">
          <span class="style-guide-block__label">Ordered list in formatted-text__body</span>
          <ol>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Nulla vitae elit libero, a pharetra augue.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Nullam id dolor id nibh ultricies vehicula ut id elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
          </ol>
        </div>

        <div class="style-guide-block content-block formatted-text__body">
          <span class="style-guide-block__label">Unordered list in formatted-text__body</span>
          <ul>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Nulla vitae elit libero, a pharetra augue.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Nullam id dolor id nibh ultricies vehicula ut id elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
          </ul>
        </div>
      </div>

      <div class="content--secondary col-4">
        <div class="style-guide-block">
          <span class="style-guide-block__label">Secondary content block</span>
          <div class="style-guide-block">
            <span class="style-guide-block__label">Icons</span>
            <div>
              <span class="icon icon-social-facebook"></span>
              <span class="icon icon-social-instagram"></span>
              <span class="icon icon-social-linkedin"></span>
              <span class="icon icon-social-youtube"></span>
              <br />
              <span class="icon icon-ui-arrow--down"></span>
              <span class="icon icon-ui-arrow--left--sm"></span>
              <span class="icon icon-ui-arrow--right"></span>
              <span class="icon icon-ui-arrow--right--sm"></span>
              <span class="icon icon-ui-arrow--up"></span>
              <span class="icon icon-ui-checkmark--sm"></span>
              <span class="icon icon-ui-close"></span>
              <span class="icon icon-ui-close--sm"></span>
              <span class="icon icon-ui-loader"></span>
              <br />
              <span class="icon icon-ui-login"></span>
              <span class="icon icon-ui-logout"></span>
              <span class="icon icon-ui-mail"></span>
              <span class="icon icon-ui-plus"></span>
              <span class="icon icon-ui-minus"></span>
              <span class="icon icon-ui-phone"></span>
              <span class="icon icon-ui-search"></span>
              <br />
              <span class="icon icon-ui-nav-1"></span>
              <span class="icon icon-ui-nav-dashboard"></span>
              <span class="icon icon-ui-nav-inwisselen"></span>
              <span class="icon icon-ui-nav-more"></span>
              <span class="icon icon-ui-nav-sparen"></span>
              <span class="icon icon-ui-nav"></span>
            </div>
          </div>
        </div>
        <div class="style-guide-block">
          <span class="style-guide-block__label">Form controls</span>
          <div class="form-group">
            <label for="text">Text</label>
            <input type="text" name="text" />
          </div>
          <div class="form-group">
            <label for="text">Password</label>
            <input type="password" name="password" /><i class="icon icon-ui-eye-open"></i>
          </div>
          <div class="form-group">
            <label for="select">Select</label>
            <select name="select">
              <option value="1">Option 1</option>
              <option value="1">Option 2</option>
            </select>
          </div>
          <div class="form-group">
            <input type="radio" id="radio_1" name="radio" /><label for="radio_1">Radio 1</label>
            <input type="radio" id="radio_2" name="radio" /><label for="radio_2">Radio 2</label>
          </div>
          <div class="form-group"><input type="checkbox" id="checkbox" name="checkbox" /><label for="checkbox">Checkbox</label></div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="content--highlighted">
        <div class="style-guide-block">
          <span class="style-guide-block__label">Stickers</span>
          <div class="sticker sticker--sm">
            <span class="sticker__counter">000</span>
            <span class="sticker__label">Air Miles</span>
          </div>
          <div class="sticker sticker--md">
            <span class="sticker__counter">000</span>
            <span class="sticker__label">Air Miles</span>
          </div>
          <div class="sticker sticker--lg">
            <span class="sticker__top-label">vanaf</span>
            <span class="sticker__counter">000</span>
            <span class="sticker__label">Air Miles</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>
